import axios from "axios";
import endpoints from "config/endpoints";
import { useCallback } from "react";
import { getEnvVar } from "utils/environment";
import { decryptWithAES } from 'converter/converter'

const AUTH_KEY = "AUTH_TOKEN";

const requestBody = new URLSearchParams();
requestBody.append("grant_type", "client_credentials");

const hasTokenExpired = ({ consented_on, expires_in }) => {
  if (!consented_on) {
    return true;
  }

  return new Date() > new Date((consented_on + expires_in) * 1000);
};

const useAuthToken = () => {
  const decodedClientId = decryptWithAES(getEnvVar("CLIENT_ID"))
  const decodedBasic = decryptWithAES(getEnvVar("API"))  
  const buildAuthorization = 'Basic ' + decodedBasic

  return useCallback(() => {
    const getToken = async () => {
      const result = await axios.request({
        method: "POST",
        url: `${getEnvVar("HOST")}${endpoints.authToken()}`,
        data: requestBody,
        headers: {
          'Authorization': buildAuthorization,
          'Content-Type': 'application/x-www-form-urlencoded',
          "X-IBM-Client-Id": decodedClientId
        }
      });

      sessionStorage.setItem(AUTH_KEY, JSON.stringify(result?.data));
      return result?.data?.access_token;
    };

    const currentToken = JSON.parse(sessionStorage.getItem(AUTH_KEY) || "{}");
    if (!hasTokenExpired(currentToken)) {
      return Promise.resolve(currentToken.access_token);
    }

    return getToken();
  }, []);
};

export default useAuthToken;
